import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ShieldCheck } from 'lucide-react';
import { LogoMark } from './Logo';
import { CLINIC } from '../mock';

const Footer = () => (
  <footer className="bg-[#f4f8fc] border-t border-border mt-4">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <LogoMark size={42} />
            <div>
              <div className="font-heading font-semibold tracking-[0.15em] text-navy text-sm uppercase">{CLINIC.name}</div>
              <div className="font-heading tracking-[0.3em] text-[9px] text-[#7aa6cf] uppercase">{CLINIC.tagline}</div>
            </div>
          </div>
          <p className="text-sm text-muted-foreground max-w-md leading-relaxed">
            Specialized virtual mental health care for insomnia, anxiety, depression, PTSD, and more — delivered with compassion and evidence-based expertise.
          </p>
          <Link
            to="/getting-started"
            className="inline-flex items-center mt-6 rounded-full bg-navy text-white px-5 py-2.5 text-sm font-heading font-medium hover:bg-[#2c4d76] transition-colors"
          >
            Get Started
          </Link>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-navy tracking-wide mb-4 text-sm uppercase">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            {[
              { label: 'Home', to: '/' },
              { label: 'Services', to: '/services' },
              { label: 'Getting Started', to: '/getting-started' },
              { label: 'Wellness Tools', to: '/tools' },
              { label: 'FAQs', to: '/faqs' },
              { label: 'About Us', to: '/about' },
              { label: 'Blog', to: '/blog' },
            ].map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-muted-foreground hover:text-navy transition-colors">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-navy tracking-wide mb-4 text-sm uppercase">Contact</h4>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-center gap-2.5"><Phone size={16} className="text-[#3d6a9c]" /><a href={CLINIC.phoneHref} className="hover:text-navy">{CLINIC.phone}</a></li>
            <li className="flex items-start gap-2.5"><Mail size={16} className="text-[#3d6a9c] mt-0.5" /><a href={CLINIC.emailHref} className="hover:text-navy break-all">{CLINIC.email}</a></li>
            <li className="flex items-center gap-2.5"><MapPin size={16} className="text-[#3d6a9c]" />{CLINIC.location}</li>
            <li className="flex items-center gap-2.5"><ShieldCheck size={16} className="text-[#3d6a9c]" />PSYPACT Authorized · 44 States</li>
          </ul>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-muted-foreground">{CLINIC.copyright} · {CLINIC.legalName}. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
